/**
 * Lazy Section Loader
 * Date Modified: 2025-10-08
 * Author: Claude Code
 * Purpose: Defer loading of below-the-fold section scripts until visible
 * Scope: Reduces initial JavaScript execution and improves TTI without touching vendor.js/theme.js
 */

(function() {
  'use strict';

  // Early exit if Intersection Observer not supported
  if (!('IntersectionObserver' in window)) {
    return;
  }

  const loadedScripts = new Set();

  const config = {
    rootMargin: '100px 0px', // Load scripts 100px before section becomes visible
    threshold: 0.01
  };

  const sectionObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        const section = entry.target;
        const scripts = section.dataset.lazyScripts;

        if (scripts) {
          const scriptList = scripts.split(',');
          scriptList.forEach(function(scriptName) {
            loadScript(scriptName.trim());
          });

          delete section.dataset.lazyScripts;
          sectionObserver.unobserve(section);
        }
      }
    });
  }, config);

  function loadScript(scriptName) {
    // Check if script already loaded or in process
    if (loadedScripts.has(scriptName)) {
      return;
    }

    // Check if script already exists in DOM
    if (document.querySelector('script[src*="' + scriptName + '"]')) {
      loadedScripts.add(scriptName);
      return;
    }

    loadedScripts.add(scriptName);

    const script = document.createElement('script');
    script.src = window.Shopify.cdnHost + '/s/files/1/0653/7157/9880/files/' + scriptName;
    script.defer = true;
    script.onerror = function() {
      // Fallback to standard asset URL if CDN path fails
      script.src = window.Shopify.routes.root + 'cdn/shop/t/1/assets/' + scriptName;
    };
    document.head.appendChild(script);
  }

  // Observe sections marked for lazy loading
  function initLazySections() {
    const lazySections = document.querySelectorAll('[data-lazy-scripts]');
    lazySections.forEach(function(section) {
      sectionObserver.observe(section);
    });
  }

  // Initialize after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazySections);
  } else {
    initLazySections();
  }
})();
